import React, { useMemo } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { toCurrency, getGameTicketImage } from '../utils/helper';
import LottoMatikLogo from '../assets/images/lottomatik.jpeg';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export default function TicketTemplate1({ transaction, displayName }) {
  const GameImage = getGameTicketImage(transaction.bets[0].gameSettingsId);
  const groupedBets = useMemo(() => {
    // First group by bettingOption and combination length
    const byBettingOption = {};

    for (const bet of transaction.bets) {
      const key =
        bet.bettingOption === 'ramble'
          ? `${bet.bettingOption}-${
              [...new Set(bet.combination.split(''))].length
            }`
          : bet.bettingOption;

      if (!byBettingOption[key]) {
        byBettingOption[key] = [];
      }
      byBettingOption[key].push(bet);
    }

    // Then group each betting option's bets into groups of 6
    const result = {};
    for (const [option, optionBets] of Object.entries(byBettingOption)) {
      result[option] = [];
      for (let i = 0; i < optionBets.length; i += 6) {
        result[option].push(optionBets.slice(i, i + 6));
      }
    }

    return result;
  }, [transaction]);

  const drawId = dayjs(transaction.drawDate)
    .diff(dayjs('2025-04-12'), 'day')
    .toString()
    .padStart(7, '0');

  return (
    <div className='grid max-h-0 overflow-hidden'>
      <div
        id='print-ticket'
        className='w-[217px] text-[10px] flex flex-col gap-4 bg-white font-typeR font-bold'
      >
        {Object.entries(groupedBets).map(([option, bets]) => (
          <div key={option} className='flex flex-col gap-10'>
            {bets.map((betGroup, index) => (
              <div key={index} className='flex flex-col gap-1'>
                <div className='flex justify-between items-center'>
                  <div>
                    <img className='h-16' src={GameImage} />
                    <div className='flex flex-col gap-2'>
                      <div className='flex flex-col items-baseline leading-tight'>
                        <span>Bet Date:</span>
                        <span>
                          {dayjs(transaction.bets[0].createdAt).format(
                            'YYYY/MM/DD ddd HH:mm'
                          )}
                        </span>
                      </div>
                      <div className='flex flex-col items-baseline leading-tight'>
                        <span>Draw Date:</span>
                        <span>
                          {dayjs(transaction.drawDate).format(
                            'YYYY/MM/DD ddd'
                          ) +
                            ' ' +
                            dayjs(transaction.drawTime, 'HH:mm').format('H:mm')}
                        </span>
                      </div>
                      <div className='flex flex-col items-baseline leading-tight'>
                        <span>Draw ID: {drawId}</span>
                      </div>
                      <div className='flex flex-col items-baseline leading-tight'>
                        <span>Agent ID: {displayName}</span>
                      </div>
                      <div className='flex flex-col items-baseline leading-tight'>
                        <span>
                          Ticket Price: ₱
                          {toCurrency(
                            betGroup
                              .filter((bet) => bet.bettingOption !== 'S/O')
                              .reduce((acc, bet) => +acc + +bet.amount, 0)
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* QR Code */}
                  <div className='flex flex-col gap-3'>
                    <img src={LottoMatikLogo} className='w-[100px]' />
                    <QRCodeSVG
                      value={transaction.id}
                      width={100}
                      height={100}
                      level='H'
                    />
                  </div>
                </div>
                {/* <div className='flex flex-col items-baseline leading-tight mt-1'>
                  <span>Inclusive of the Documentary Stamp Tax</span>
                </div> */}

                <div className='flex flex-col mt-2'>
                  <span className='text-[11px] tracking-[5px]'>
                    {dayjs(transaction.bets[0].createdAt).format('YYMMDD') +
                      new Date().getTime().toString()}
                  </span>
                  <span>Ticket Number: </span>
                </div>
                <div className='w-full border border-black h-6'></div>
                <span className='mb-2'>Signature</span>
                {betGroup.map((bet, index) => (
                  <div key={index}>
                    <div className='flex flex-col'>
                      <div className='flex justify-between'>
                        <div className='text-left'>
                          {option === 'target' ? (
                            <div>Standard</div>
                          ) : option === 'ramble-3' ? (
                            <div>Rambolito 6</div>
                          ) : option === 'ramble-2' ? (
                            <div>Rambolito 3</div>
                          ) : (
                            <div>{option}</div>
                          )}
                          <span className='uppercase'>
                            {String.fromCharCode(97 + index)}
                          </span>
                        </div>
                        <div className='flex flex-col gap-1 items-end'>
                          <span
                            className={` text-xs text-right ${
                              transaction.bets[0].gameSettingsId === 1
                                ? 'tracking-[20px] -mr-[20px]'
                                : 'tracking-[4px] -mr-[4px]'
                            }`}
                          >
                            {bet.combination}
                          </span>
                          {bet.bettingOption === 'S/O' ? (
                            <span>S/O</span>
                          ) : (
                            <span>Price: ₱{toCurrency(bet.amount)}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
        <div className='h-4'></div>
      </div>
    </div>
  );
}
